/** ConvexPolygonShape3D resource slice: claims the type name, re-exports its decode. */
import { registerGenericResourceSlice } from '../../sliceRegistration';
registerGenericResourceSlice('convexpolygonshape3d', ['ConvexPolygonShape3D']);
export { decodeConvexPolygonShape3D } from './decode';
//# sourceMappingURL=index.js.map